import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

type HideProps = { display?: string; width?: string; height?: string };

export const HideMobile = styled.div<HideProps>`
  display: none;

  ${QUERIES.largeTabletAndUp} {
    display: ${({ display }): string => display ?? 'block'};
    width: ${({ width }): string | undefined => width};
    height: ${({ height }): string | undefined => height};
  }
`;

export const HideDesktop = styled.div<HideProps>`
  display: ${({ display }): string => display || 'block'};
  width: ${({ width }): string | undefined => width};
  height: ${({ height }): string | undefined => height};

  ${QUERIES.largeTabletAndUp} {
    display: none;
  }
`;
